import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Eslide.css";
export default class Eslide extends React.Component{
	render()
	{
		return(
            <h1>Hello Emergency</h1>
		// <div>
        //     <Carousel className="main-slide">
        //         <div>
                
        //         <img src="./images/es1.jpg"alt="asgfsdg" height="600px"width="400px"/>
                
        //         </div>
        //         <div>
               
        //         <img src="./images/es2.jpg"alt="asgfsdg"  height="600px"width="400px"/>
                              
        //         </div>
        //         <div>
               
        //         <img src="./images/es3.jpg"alt="asgfsdg"  height="600px"width="400px"/>
                   
        //         </div>
        //         <div>
               
        //         <h3  className="manyh3"></h3>
        //         <img src="./images/es4.jpg"alt="asgfsdg"  height="600px"width="400px"/>
                   
        //         </div>
                
        //     </Carousel>
        //     </div>
			
			
		)
	} 
}